import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { HeaderComponent } from './Shared/header/header.component';
import { FooterComponent } from './Shared/footer/footer.component';
import { AppRoutingModule, routingComponents } from './app-routing-module';
import { AppMaterialModule, appMaterialComponents } from "./app-material-module";
import { AlertifyService } from './Service/Common/alertify-service.service';
import { AuthGuard } from './guards/auth.guard';
import { LoaderComponent } from './Shared/loader/loader.component';
import { MatSpinner } from '@angular/material';
import { ContentComponent } from './component/content/content.component';
import { MenuDataService } from './Service/Common/menudata.service';
import { HomeComponent } from './Component/home/home.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { StreamComponent } from './component/stream/stream.component';
import { BlogsComponent } from './component/blogs/blogs.component';
import { NewsComponent } from './component/news/news.component';
import { CustomFormComponent } from './Component/customform/customform.component';
import { BestplayerComponent } from './Component/bestplayer/bestplayer.component';
import { TournamentsComponent } from './Component/tournaments/tournaments.component';
import { NewplayersComponent } from './Component/newplayers/newplayers.component';
import { ToolsComponent } from './Component/tools/tools.component';
import { AboutusComponent } from './Component/aboutus/aboutus.component';
import { ProamateurtournamentComponent } from './Component/proamateurtournament/proamateurtournament.component';
import { RegularstreamComponent } from './Component/regularstream/regularstream.component';
import { AxieleagueComponent } from './Component/axieleague/axieleague.component';
import { SponsorComponent } from './Component/sponsor/sponsor.component';
import { RankingComponent } from './component/ranking/ranking.component';
import { ScheduleComponent } from './component/schedule/schedule.component';
import { StatisticsComponent } from './component/statistics/statistics.component';



// export const appRoutes: Routes = [ 
//   { path: '', component: HomeComponent},
//   { path: 'home', component: HomeComponent},  
//   { path: 'aboutus', component: ContentComponent} ,
//   { path: '**', component: ContentComponent} ,
//   { path:'stream' , component:StreamComponent}

// ];
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    routingComponents,
    LoaderComponent,
    MatSpinner,    
    ContentComponent, 
    HomeComponent, 
    StreamComponent, 
    BlogsComponent, 
    NewsComponent,
     CustomFormComponent,
      BestplayerComponent, 
      TournamentsComponent, 
      NewplayersComponent, ToolsComponent,
       AboutusComponent,
      RegularstreamComponent,
      ProamateurtournamentComponent,
      AxieleagueComponent,
      SponsorComponent,
      RankingComponent,
      ScheduleComponent,
      StatisticsComponent
      
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    AppRoutingModule,
    AppMaterialModule,
    appMaterialComponents
  ],
    
  bootstrap: [AppComponent],
  entryComponents: [
  ],
exports: [RouterModule],})
export class AppModule {
  token = localStorage.getItem("loginToken");
}
